import { Component, OnInit, Renderer2  } from '@angular/core';
import { UiStyleService } from 'src/app/common/services/ui-style.service';


@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss']
})
export class ToggleSwitchComponent implements OnInit {
  public theme: boolean;


  constructor(
    private renderer: Renderer2,
    private themeService: UiStyleService

  ) { }

  ngOnInit(): void {
  }

  changeTheme() {
    this.themeService.toggle();
  }

}
